export default __webpack_public_path__ + "static/media/illustration-recruit-3-w.55bbf36e.webp";